import type { CookieDefinition, CookieOptions } from "./cookies";

export function cookieOptions(
  cookie: CookieDefinition,
  overrides: Partial<CookieOptions> = {},
): CookieOptions {
  return { ...cookie.options, ...overrides };
}
